module.exports = __webpack_public_path__ + "img/WechatIMG15cc75e7b2f15a688d7ff4b905dfb2ce.a072235b.png";